import { combineReducers, configureStore } from '@reduxjs/toolkit';
import user from './userSlice';
import filters from './filtersSlice';
import modal, { FilesAPI } from './modalSlice';
import statisticsSlice from './statisticsSlice'
import { AppealsFromAppAPI } from './appealsFromAppAPI';
import { StatisticsAPI } from './statisticsAPI';

const rootReducer = combineReducers({
  user,
  filters,
  modal,
  statisticsSlice,
  [AppealsFromAppAPI.reducerPath]: AppealsFromAppAPI.reducer,
  [StatisticsAPI.reducerPath]: StatisticsAPI.reducer,
  [FilesAPI.reducerPath]: FilesAPI.reducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      AppealsFromAppAPI.middleware,
      FilesAPI.middleware,
      StatisticsAPI.middleware
    ),
  devTools: process.env.NODE_ENV != 'production',
});
export default store;

export type RootState = ReturnType<typeof rootReducer>;
